const transition = 'transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300';

export default transition;
